<template>
    <div v-if="isLoading">
        <b-row>
            <b-col md="6">
                <atom-spinner
                    :animation-duration="1000"
                    :size="60"
                    color="#ff1d5e"
                    class="float-right my-5"
                />
            </b-col>
        </b-row>
    </div>
    <div v-else class="animated fadeIn pt-1">
        <b-row>
            <b-col md="8">
                <ul class="heading-ul">
                    <li>
                        <button size="sm" @click="backButton">
                            <i
                                class="fa fa-arrow-left"
                                aria-hidden="false"
                                style="font-size: 18px; color: rgb(38, 38, 38)"
                            ></i>
                        </button>
                    </li>
                    <li><h4>Feature Details</h4></li>
                </ul>
            </b-col>
            <b-col md="4">
                <div class="EditDeleteFeature">
                    <b-button
                        size="sm"
                        @click="onClickEdit(featureId)"
                        class="mr-2 my-0 main-navigation-button"
                        variant="primary"
                        style="height: 40px"
                    >
                        Edit Feature
                    </b-button>
                    <b-button
                        size="sm"
                        @click="deleteFeature(featureId)"
                        class="mr-2 my-0 main-navigation-button"
                        variant="danger"
                        style="height: 40px"
                    >
                        Delete Feature
                    </b-button>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-card border-variant="info">
                    <b-row>
                        <b-col md="6">
                            <h4>Feature Name</h4>
                            <p>
                                <strong>{{ getFeatureDetails.name }}</strong>
                            </p>
                        </b-col>
                        <b-col md="6">
                            <h4>Description</h4>
                            <p class="mb-0">
                                <strong style="white-space: pre-wrap">{{
                                    getFeatureDetails.description
                                }}</strong>
                            </p>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="12"><h4>Added Permission</h4> </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col md="12">
                <b-card border-variant="info">
                    <div>
                        <b-table
                            responsive
                            :items="tableData"
                            :fields="tableFields"
                            thead-class="header"
                            show-empty
                            :no-border-collapse="true"
                            :current-page="currentPage"
                            :per-page="perPage"
                            :filter="filter"
                            @filtered="onFilter"
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                        >
                            <template slot="cell(empty)">
                                <div v-if="isLoading" class="text-center">
                                    <span><b>Loading...</b></span>
                                </div>
                                <div v-else class="text-center">
                                    No data available.
                                </div>
                            </template>
                        </b-table>
                    </div>
                    <div style="float: right">
                        <b-pagination
                            v-model="currentPage"
                            :per-page="perPage"
                            :total-rows="filterCount"
                            aria-controls="my-table"
                            prev-text="Prev"
                            next-text="Next"
                            hide-goto-end-buttons
                        ></b-pagination>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { mapState } from "vuex";
import ebSelect from "@/components/FormElements/Select.vue";
import ebButton from "@/components/FormElements/Button";
import { AtomSpinner } from "epic-spinners";

export default {
    name: "features",
    props: {},
    components: {
        ebSelect,
        ebButton,
        AtomSpinner,
    },
    data() {
        return {
            isLoading: false,
            featureId: this.$route.params.id,
            filterCount: 0,
            filter: "",
            sortBy: "createdAt",
            sortDesc: true,
            currentPage: 1,
            perPage: 10,
            tableFields: [
                {
                    label: "Resource",
                    key: "resource",
                },
                {
                    label: "Permission",
                    key: "name",
                },
                {
                    label: "Method",
                    key: "action",
                },
            ],
            tableData: [],
        };
    },
    computed: {
        ...mapState({
            getFeatureDetails: (state) => state.feature.featureDetails,
        }),
    },
    methods: {
        onFilter(list) {
            this.filterCount = list.length;
            this.currentPage = 1;
        },
        backButton() {
            this.$router.push({ path: "/features" });
        },
        selectedPermissions() {
            this.getFeatureDetails?.permission?.filter((permit) => {
                this.tableData.push(permit);
            });
        },
        async deleteFeature(featureId) {
            await this.$swal({
                title: "Are you sure?",
                text: "You can't revert this action!!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                 reverseButtons: true,
            }).then((result) => {
                if (result.value) {
                    this.isLoading = true;
                    this.$store
                        .dispatch("feature/deleteFeature", featureId)
                        .then((result) => {
                            this.$toasted.success(
                                "Feature Deleted Successfully",
                            );
                            this.$store
                                .dispatch("feature/fetchFeatureList")
                                .catch((error) => {
                                    this.$toasted.error(error.message);
                                });
                        });
                    this.isLoading = false;
                    this.backButton();
                }
            });
        },
        onClickEdit(featureId) {
            this.$router.push({
                name: "edit-feature",
                params: { id: featureId },
            });
        },
    },
    async mounted() {
        this.isLoading = true;
        await this.$store.dispatch("permission/fetchAllPermission");
        await this.$store.dispatch(
            "feature/fetchFeatureDetails",
            this.$route.params.id,
        );
        this.selectedPermissions();
        this.isLoading = false;
    },
};
</script>

<style>
.searchField {
    font-size: 12px;
    font-weight: 600;
    border-radius: 30px;
    padding: 17px;
    height: 36px;
}
.table td {
    text-align: center;
}
tbody tr:nth-child(2n + 1) {
    border-bottom: 1px solid #e8e5e5;
}
.EditDeleteFeature {
    text-align: right;
    margin-bottom: 15px;
}
.EditDeleteFeature button.btn {
    width: 120px;
    border-radius: 6px;
    margin-right: 8px;
    margin-left: 8px;
}
</style>
